import type { VsmContext, MasterPageConfigEntry, MasterPageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ComponentsLoaderMasterPageConfig } from '../types'
import { name } from '../symbols'

const componentsLoaderMasterPageConfig: MasterPageConfigFn<ComponentsLoaderMasterPageConfig> = ({
	api,
	funcLib,
}: VsmContext) => {
	const masterPageData = api.components.getCompData<{ layoutSettings?: { headerToPagesGap?: string } }>('masterPage')
	return { isLazyLoadCompatible: funcLib!.isSiteLazyLoadCompatible(masterPageData ?? {}) }
}

export const masterPageConfig: MasterPageConfigEntry<ComponentsLoaderMasterPageConfig> = {
	name,
	configFactory: componentsLoaderMasterPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
